module.exports = __webpack_public_path__ + "img/Syria.02df412b.gif";